import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
const technicalTemplateImportStatusesService = {
  get(claimGroupId) {
    return fetch(`/api/claim_groups/${claimGroupId}/technical_template_import_status`, request.get);
  }
};
export default technicalTemplateImportStatusesService;